import { Address, facadeFactory } from '@spartacus/core'
import { Injectable } from '@angular/core'
import { CHECKOUT_CORE_FEATURE } from '@spartacus/checkout/base/root'

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: MbCheckoutDeliveryFacade,
      feature: CHECKOUT_CORE_FEATURE,
      methods: [
        'createAndSetAddressWithoutDeliveryMode',
        'setDeliveryAddressWithoutDeliveryMode'
      ],
      async: true,
    }),
})
export abstract class MbCheckoutDeliveryFacade {
  /**
   * Create and set a delivery address without delivery mode using the address param
   *
   * @param address : Address to be created and set
   */
  abstract createAndSetAddressWithoutDeliveryMode(address: Address): void

  /**
   * Set delivery address without delivery mode
   *
   * @param address : Address to be set
   */
  abstract setDeliveryAddressWithoutDeliveryMode(address: Address): void
}
